<div class="modal-header">
    <h4 class="modal-title pull-left">Edit {{model.IsPortfolio ? "Portfolio" : "Property"}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModel($event)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
  <div class="margin-bottom-15">
    <div class="modal-data-box">
      <h4 style="font-weight:600;">{{model.ShowDisplayName ? model.DisplayName : model.TenantName}}</h4>
      <p>{{state != null && state.length > 0 ? state+"," : ""}} {{city}}</p>
      <p>{{brokerage}}</p>
    </div>

  </div>

  <div class="form-group margin-top-10">
    <label class="form-label">
      Asking Price
      <!--<span class="star">*</span>-->
      <label *ngIf="model.IsPortfolio" class="custom-checkbox " style="float:right; height:10px" for="chkCalcAskingPrice">
        <input #inputCalcAskingPrice id="chkCalcAskingPrice" (click)="autoCalcAskingPrice(inputCalcAskingPrice.checked)" type="checkbox" [(ngModel)]="model.AutoCalcPrice"> Auto Calc
        <i></i>
      </label>
    </label>
    <div class="textbox-with-btn-left" *ngIf="!model.Unpriced">
      <input type="text" #txtAskingPrice="ngModel" inputmode="numeric" name="txtAskingPrice" dropSpecialCharacters="false" mask="separator.0"
             [(ngModel)]="model.Price" class="form-control " maxlength="18" thousandSeparator="," (change)="updateCapRate()">

      <!--<input class="form-control" dropSpecialCharacters="false" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  [(ngModel)]="currentSalesDetails.SalePrice" maxlength="15"
  value="{{currentSalesDetails.SalePrice|number}}">-->
      <!--<input class="form-control"  #txtAskingPrice="ngModel" dropSpecialCharacters="false" required [(ngModel)]="model.Price" value="{{model.Price|number}}" mask='999999999999999' maxlength="18" (keyup)="updateCapRate()">-->
      <span class="leftlabel">$</span>
      <!--<div *ngIf="(txtAskingPrice.invalid)|| (txtAskingPrice.invalid && (txtAskingPrice.dirty || txtAskingPrice.touched))">
      <p class="redtext" *ngIf="txtAskingPrice.errors.required">
          Asking Price is required
      </p>
      <p class="redtext" *ngIf="txtAskingPrice.errors.min">
          Asking Price should be greater than zero
      </p>
  </div>-->
    </div>
    <div *ngIf="model.Unpriced">
      <input type="text" disabled [(ngModel)]="model.UnpricedText"
             class="form-control">
    </div>
  </div>
  <div class="form-group" *ngIf="!model.IsPortfolio">
    <label class="form-label clearfix">
      Status
      <label class="right-align-label" *ngIf="viewSoldDetailsLink">
        <a (click)="openSolidDetails(templateSolidDetails,'sold-modal',model.PropertyStatusId)">View Sales info</a>
      </label>
    </label>
    <label class="select">
      <select class="form-control" name="lstPropertyStatus" lstPropertyStatus="ngModel" [(ngModel)]="model.PropertyStatusId" (change)="openSolidDetails(templateSolidDetails,'sold-modal',model.PropertyStatusId)">

        <option [ngValue]="item.id" *ngFor="let item of propertyStatusList">{{item.description}}</option>

      </select>
      <i></i>
    </label>

  </div>

  <div class="form-group">
    <label class="form-label">
      NOI/Rent

    </label>
    <div class="textbox-with-btn-left">
      <input type="text" #txtNOI="ngModel" inputmode="numeric" name="txtNOI" dropSpecialCharacters="false" mask="separator.0"
             [(ngModel)]="model.NOI"  class="form-control " maxlength="18" thousandSeparator="," (change)="updateCapRate()">

      <!--<input #txtNOI="ngModel" [dropSpecialCharacters]="false" maxlength="18" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  [(ngModel)]="model.NOI"
             class="form-control " (keyup)="updateCapRate()">-->
      <span class="leftlabel">$</span>
    </div>

    <!--<div *ngIf="(txtNOI.invalid)||(txtNOI.invalid && (txtNOI.dirty || txtNOI.touched))">
        <p class="redtext" *ngIf="txtNOI.errors.required">
            NOI/Rent is required
        </p>
    </div>-->
  </div>
  <div class="form-group">
    <label class="form-label">Date on Market</label>
    <div class="textbox-date">
      <input type="text" #txtDateOnMarket="ngModel" maxlength="10" [(ngModel)]="model.DateOnMarket"
             class="form-control" bsDatepicker>
      <i class="icofont icofont-ui-calendar icon"></i>
    </div>
  </div>
  <div class="form-group">
    <label class="form-label">
      {{capratetext}}
      <label class="custom-checkbox " for="checkbox12" style="float:right; height:10px" for="chkCalcCAP">
        <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" #inputCalcCAP id="chkCalcCAP" (click)="reCalcRates(inputCalcCAP.checked)" type="checkbox" [(ngModel)]="model.AutoCalcCapRate"> Auto Calc Cap Rate
        <i></i>
      </label>
    </label>
    <div class="textbox-with-btn textbox-with-2character" *ngIf="!model.Unpriced">
      <input [attr.disabled]="(disableCapRate) ? 'disabled' : null" (keyup)="model.AutoCalcCapRate=false;validateCapRate()" type="text" mask="999.99" #txtCapRate="ngModel" [dropSpecialCharacters]="false" [(ngModel)]="model.CapRate" class="form-control" (change)="validationService.onlyDecimal($event); validateCapRate();">
      <span class="rightlabel">%</span>
    </div>
    <div *ngIf="model.Unpriced">
      <input type="text" disabled [(ngModel)]="model.UnpricedText"
             class="form-control">
    </div>
    <div>
      <p class="redtext">
        {{capRateMessage}}
      </p>

    </div>
  </div>
  <div class="text-right margin-top-20">
    <div class="margin-bottom-10 text-right">
      <!--<button class="btn btn-success btn-lg  margin-bottom-5 btn-secondary" >Save</button>
      <button class="btn btn-success btn-lg" (click)="SaveProperty(2)">{{ (isDataEntryProperty && roleId == 1) ? 'Save & List': 'Save' }}</button>-->
      <button (click)="closeModel($event)" class="btn btn-default btn-lg margin-right-5">Cancel</button>
      <div class="btn-group" dropdown>
        <button id="quick-save" dropdownToggle type="button" class="btn btn-success btn-lg"
                aria-controls="dropdown-basic" (click)="!(isDataEntryProperty && (authService.Admin()|| authService.SuperAdmin())) && dataEntryPropertyStatusId != propertyStatus.Draft  && SaveProperty(2)">
          Save <span *ngIf="(isDataEntryProperty && (authService.Admin()|| authService.SuperAdmin())) || dataEntryPropertyStatusId == propertyStatus.Draft" class="caret"></span>
        </button>
        <ul id="quick-save" *dropdownMenu class="dropdown-menu"
            role="menu" aria-labelledby="button-basic">
          <li role="menuitem"><a class="dropdown-item" *ngIf="isDataEntryProperty && dataEntryPropertyStatusId == propertyStatus.Draft && authService.DataEntryStaff()" (click)="SaveProperty(1)">Save As Draft</a></li>
          <li role="menuitem"><a class="dropdown-item" *ngIf="isDataEntryProperty && (authService.Admin()||authService.SuperAdmin())" (click)="SaveProperty(3)">Save</a></li>
          <li role="menuitem"><a class="dropdown-item" (click)="SaveProperty(2)">{{ (isDataEntryProperty && (authService.Admin()||authService.SuperAdmin())) ? 'Save & List': 'Save' }}</a></li>
        </ul>
      </div>
    </div>


  </div>
</div>


<ng-template #templateSolidDetails>
    <app-sold-details (save)="addSalesDetails($event)" [modalRef]="modalRefsales" [property]="model" [currentSalesDetails]="currentSalesDetails" (close)="close($event)" [IsFromAddEditPage]="true"></app-sold-details>
</ng-template>
